export const locale = {
  'DIALOG': {
    'TRAILER': {
      'CREATE': {
        'TITLE': 'Create trailer',
        'CONFIRMBUTTON': 'Create',
      },
      'EDIT': {
        'TITLE': 'Edit trailer',
        'CONFIRMBUTTON': 'Save',
      },
      'APPROVE': {
        'TITLE': 'Approve trailer',
        'CONFIRMBUTTON': 'Approve',
        'DECLINEBUTTON': 'Cancel approval',
      },
      'NUMBER': 'Trailer number',
      'TONNAGE': 'Trailer tonnage',
      'CARRIER_SELECT': 'Select carrier',
      'INSPECTION_DATE': 'Inspection date',
      'HINT': {
        'VALID_NUMBER': 'Ex: аа1111001',
      },
      'ERROR': {
        'TRAILER_EXISTS': 'Trailer with that number exists',
        'INVALID_NUMBER': 'Invalid number. Must be like this: аа1111001',
        'INVALID_TONNAGE': 'Invalid tonnage. Must be from 1 to 99',
        'NO_CARRIER': 'Carrier not selected',
        'UNDEFINED': 'Something went wrong. Try again later.',
      },
      'APPROVED_LOCK': 'Editing forbidden for approved trailers',
    },
  },
};
